export const environment = {
  production: true,
  buildId: '3338733271221621',
  configFile: 'config.json',
};
